module.exports = __webpack_public_path__ + "static/fbanner2@2x-d6f8b4e833136e416fccd9788206a737.png";